import { PAGE_NAVIGATION } from '@pokerroom/types';

export const MEMBER_WALLET_PATH = '/admin/points-config/wallet';

export const WALLET_DESTINATIONS = [
  { section: 'vouchers', label: 'nav.walletVouchers', iconKey: 'walletVouchers', icon: 'ticket' },
  { section: 'passes', label: 'nav.walletPasses', iconKey: 'walletPasses', icon: 'id' },
  {
    section: 'monthly',
    label: 'nav.walletMonthly',
    iconKey: 'walletMonthly',
    icon: 'calendar-user',
  },
] as const;

export const isMemberWalletPath = (path: string) =>
  path === MEMBER_WALLET_PATH ||
  WALLET_DESTINATIONS.some(({ section }) => path === `${MEMBER_WALLET_PATH}/${section}`);

// The wallet view retains the existing settings page grant; it is not a new catalog key.
export const memberSettingsPermissionPath = (path: string) =>
  isMemberWalletPath(path) ? '/admin/points-config' : path;

export interface NavItem {
  label: string;
  iconKey: string;
  icon: string;
  path?: string;
  children?: { label: string; path: string; iconKey: string; icon: string }[];
  requiredRoles?: string[];
}

export function buildNavItems(
  t: (key: string) => string,
  iconOverrides?: Record<string, string>,
): NavItem[] {
  const items: NavItem[] = PAGE_NAVIGATION.map((entry) => ({
    label: t(entry.labelKey),
    iconKey: entry.iconKey,
    icon: iconOverrides?.[entry.iconKey] || entry.defaultIcon,
    ...(entry.pagePath
      ? { path: entry.pagePath }
      : {
          children: entry.children!.map((child) => ({
            label: t(child.labelKey),
            path: child.pagePath,
            iconKey: child.iconKey,
            icon: iconOverrides?.[child.iconKey] || child.defaultIcon,
          })),
        }),
  }));
  const memberIndex = items.findIndex((item) => item.iconKey === 'members');
  items.splice(memberIndex + 1, 0, {
    label: t('nav.memberSettings'),
    iconKey: 'memberSettings',
    icon: iconOverrides?.memberSettings || 'wallet',
    children: WALLET_DESTINATIONS.map(({ section, label, iconKey, icon }) => ({
      label: t(label),
      path: `${MEMBER_WALLET_PATH}/${section}`,
      iconKey,
      icon: iconOverrides?.[iconKey] || iconOverrides?.memberWallet || icon,
    })),
  });
  return items;
}
